import { Box, Stack, SvgIcon, Typography } from '@mui/material';
import dayjs from 'dayjs';
import { FormattedMessage } from 'react-intl';

import DateIcon from '../../../../../assets/svg/finalReport/details/CalendarCheck.svg?react';
import CountryIcon from '../../../../../assets/svg/finalReport/details/GlobeSimple.svg?react';
import CaseManagerIcon from '../../../../../assets/svg/finalReport/details/UserSquare.svg?react';

interface ReportHeaderDetailsProps {
  reporter: string;
  reportDate: string;
  country: string;
}

const ReportHeaderDetails = ({
  reporter,
  reportDate,
  country,
}: ReportHeaderDetailsProps) => {
  const FIXED_NAME_WIDTH = 140;
  const formattedDate = dayjs(reportDate).format('YYYY-MM-DD');

  return (
    <Box width='100%'>
      <Stack spacing={2} marginBottom='24px'>
        <Stack direction='row' width='100%' spacing={2}>
          <Stack direction='row' width={FIXED_NAME_WIDTH} spacing={1}>
            <SvgIcon
              component={CaseManagerIcon}
              inheritViewBox
              htmlColor='transparent'
            />
            <Typography color='#878787'>
              <FormattedMessage defaultMessage='Reporter' />
            </Typography>
          </Stack>
          <Typography>{reporter}</Typography>
        </Stack>
        <Stack direction='row' width='100%' spacing={2}>
          <Stack direction='row' width={FIXED_NAME_WIDTH} spacing={1}>
            <SvgIcon
              component={DateIcon}
              inheritViewBox
              htmlColor='transparent'
            />
            <Typography color='#878787'>
              <FormattedMessage defaultMessage='Report Date' />
            </Typography>
          </Stack>
          <Typography>{formattedDate}</Typography>
        </Stack>
        <Stack direction='row' width='100%' spacing={2}>
          <Stack direction='row' width={FIXED_NAME_WIDTH} spacing={1}>
            <SvgIcon
              component={CountryIcon}
              inheritViewBox
              htmlColor='transparent'
            />
            <Typography color='#878787'>
              <FormattedMessage defaultMessage='Country' />
            </Typography>
          </Stack>
          <Typography>{country}</Typography>
        </Stack>
      </Stack>
    </Box>
  );
};

export default ReportHeaderDetails;
